import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
    selector: 'app-withdrawal-cage',
    templateUrl: './withdrawal-cage.component.html',
    styleUrls: ['./withdrawal-cage.component.scss'],
})

export class WithdrawalCageComponent extends WithdrawalBaseComponent implements OnInit {
    @ViewChild(IonContent) content: IonContent;

    public labels: DepositMainLabels;
    public error = null;
    public withdrwalSuccess = false;
    public accountBalances: BalanceModel;

    public withdrawalForm: FormGroup;

    public amount: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    public buttonDisabled: boolean = false;

    protected imageName: string;
    protected logoText: string;

    constructor(
        public addressService: AddressService,
        public cashierService: CashierService,
        public cashierContentService: CashierContentService,
        public navigator: Navigator,
        public events: EventsService,
        public withdrawService: WithdrawalService,
        public balanceService: AccountBalanceService,
        public utils: UtilsService,
        public configService: ConfigService,
        public successMessageService: SuccessMessageService
    ) {
        super();
        this.successMessageService.clearMessage();
        this.error = null;
        this.labels = new DepositMainModel();
    }

    ionViewWillEnter() {
        this.getVendorData();
    }

    ngAfterViewInit() {
        let fileName = this.configService.getState() == 'Pennsylvania' ? 'casinocage-pa' : 'casinocage-nj';
        this.cashierContentService.getPageConfig(fileName).then((response: DepositMainLabels) => {
            this.labels = response;
        });
    }

    ngOnInit() {
        this.buttonDisabled = false;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl('')
            }
        )
        this.amount = this.withdrawalForm.get('amount');
    }

    ionViewDidEnter() {
        this.successMessageService.clearMessage();
        this.onGetBalance();
        this.withdrwalSuccess = false;
    }

    onGetBalance() {
        this.balanceService.getBalance().subscribe((balance: BalanceModel) => {
            this.accountBalances = balance
        });
        this.error = null;
    }

    onWithdraw() {
        this.buttonDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;

        this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("CAGE");
        this.withdrawalForm.value.isCagePayout = true;

        this.withdrawService.callWithdraw(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    const depositEventData: AffiliateTrackerCallbackParams = {
                        customer_id: this.cashierService.customer.customerId,
                        amount: this.withdrawalForm.get('amount').value
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);
                    this.amount.setValue('');
                    this.amount.markAsPristine();
                    this.amount.markAsUntouched();
                    this.successMessageService.setMessage('Your withdrawal request has been received.');
                    this.balanceService.updateBalance();
                    this.content.scrollToTop();
                    this.withdrwalSuccess = true;

                    this.buttonDisabled = false;
                }
            },
            (error) => {
                this.error = this.handleError(error);
                this.buttonDisabled = false;
            }
        )

        this.error = null;
    }

    private getVendorData(): any {
        return this.cashierService.getActiveTypesCategories({ include_types: true }).subscribe((response) => {
            console.log('res', response);
            if (response?.result === 1) {
                const payload = response?.payload.find(item => item.code === 'CAGE');
                this.imageName = payload?.image_url;
                this.logoText = payload?.name;
            }
        }, error => {
            console.error('Casino Cage Withdrawala getActivePaymentTypes', error);
        });
    }

}
